<!-- 修改密码 -->
<template>
  <div>
    <el-form :model="form" :rules="disabled?[]:rules" ref="ruleForm" label-position="right" label-width="100px"
      class="demo-ruleForm" validate-on-rule-change="true">
      <el-row>
        <el-col>
          <el-form-item label="原密码：" prop="oldPassword">
            <el-input v-model="form.oldPassword" type="password" show-password></el-input>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item label="新密码：" prop="newPassword">
            <el-input v-model="form.newPassword" type="password" show-password></el-input>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item label="确认密码：" prop="newPassword1">
            <el-input v-model="form.newPassword1" type="password" show-password></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div v-if="disabled" class="zc" @click="prompt()"></div>
  </div>
</template>
<script>
  import { resetRouter } from "@/router/router"
  import { updatePassword, getUserRule } from "@/api/system/user"
  import { mapGetters } from "vuex"
  import md5 from "js-md5"
  export default {
    components: {
    },
    props: { disabled: Boolean },
    computed: {
      ...mapGetters(["userRule"]),
    },
    data() {
      var validatePass2 = (rule, value, callback) => {
        if (value === "") {
          callback(new Error("请再次输入密码"))
        } else if (value != this.form.newPassword) {
          callback(new Error("两次输入密码不一致!"))
        } else {
          callback()
        }
      }
      return {
        rules: {
          oldPassword: [
            {
              required: true,
              message: "请输入原密码",
            }
          ],
          newPassword: [
            {
              required: true,
              message: "请输入新密码",
            }
          ],
          newPassword1: [
            {
              validator: validatePass2,
            },
            {
              required: true,
              message: "请输入确认密码",
            }
          ]
        },
        form: {
          oldPassword: "",
          newPassword: "",
          newPassword1: "",
        },
      }
    },
    created() {
      // this.passwordFun();
      this.passwordFun(); //获取校验
    },
    mounted() {
    },
    activated() {
    },
    methods: {
      // 提示
      prompt(){
        this.$message({message:"点击右上角的编辑按钮进行编辑操作"});
      },
      // 密码校验
      passwordFun() {
        const data = this.userRule;
        this.$store.dispatch('UserRule', data);
        // MESSAGE 正则提示 CDXZ 最小长度  MMZCGZ 密码组成规则
        let arr = [];
        if (data.BHDXZM == 1) {  // 包含大写字母
          arr.push("A-Z");
        }
        if (data.BHXXZM == 1) {  // 包含小写字母
          arr.push("a-z");
        }
        if (data.BHTSZF == 1) {  // 包含特殊符号
          arr.push("#@!~%^&*.");
        }
        if (data.BHSZ == 1) {  // 包含数字
          arr.push("\\d");
        }
        let a = "", b = ""
        for (let i = 0; i < arr.length; i++) {
          const e = arr[i];
          a += `(?=.*[${e}])`;
          b += e;
        }
        let rules=[
          { required: true, message: "请输入密码" },
          {min: Number(data.CDXZ), message: `密码长度最少为${data.CDXZ}位`},
        ]
        if(arr.length>0){
          rules.push({pattern: new RegExp(`${a}[${b}]`),message: data.MESSAGE});
        }
        this.rules.newPassword.push(...rules);
        // console.log(this.rules);
      },
      //提交
      async handleSubmit(form) {
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid) {
            try {
              // let res = await updatePassword(md5(this.form.oldPassword), md5(this.form.newPassword), md5(this.form.newPassword1))
              let res = await updatePassword(this.form.oldPassword, this.form.newPassword, this.form.newPassword1)
              if (res.data.success) {
                this.$message.success("修改密码成功!");
                await this.$store.dispatch("LogOut")
                resetRouter()
                this.$router.push({ path: "/login" })
              } else {
                this.$message.error(res.data.msg)
              }
            } catch (error) {
            }
          } else {
            this.$message.warning("请按提示要求输入密码!");
          }
        });
      },
      clearValidateorForm(){
        this.$refs.ruleForm.clearValidate()
        this.form = {oldPassword: "",newPassword: "",newPassword1: ""}
      }
    },
  }
</script>

<style lang="scss" scoped>
  /deep/.el-form-item {
    margin-bottom: 0px !important;
    border: none;
  }

  /deep/.el-form-item__label {
    font-size: 15px !important;
  }

  /deep/.el-input__inner {
    background-color: #fff;
    border: none;
    border-bottom: 1px solid #DCDFE6;
    height: 40px !important;
    line-height: 40px !important;
    font-size: 14px !important;
  }

  /deep/.el-col {
    margin-bottom: 0px !important;
  }
  /deep/.el-form-item__error {
    font-size: 14px;
    top: 55% !important;
  }

  .zc{
      position: absolute;
      height: 100%;
      width: 100%;
      left: 0px;
      top: 2px;
      z-index: 10;
    }
</style>
